import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ShowHideTable } from "../../components/ShowHideTable";
import SubHeaderBox from "../../components/SubHeaderBox";
import InventoryPackagingTable from "./Table";
import { getSystemBoundarySubcategory } from "../../../../../apis/Business/InventoryApi";
import inventoryPackagingIcon from "../../../../../assets/design-revamp-company/category-icons/inventory_packaging_icon.svg";
const InventoryIngoingPackaging = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState();
  const [systemBoundaryPackaging, setSystemBoundaryPackaging] = useState();
  useEffect(() => {
    getSystemBoundarySubcategory({
      businessId: businessId,
      setSystemBoundarySubCategory: setSystemBoundaryPackaging,
      subcategory: "packaging_ingoing_delivery",
    });
  }, [businessId]);

  return (
    <div className="component-energy-contents">
      <div style={{ marginTop: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <SubHeaderBox
            subTitle={t("INVENTORY_INGOING_PACKAGING")}
            subDescription={t("INVENTORY_INGOING_PACKAGING_DESC")}
            isNormal={true}
            number={"5.1.5A"}
            icon={inventoryPackagingIcon}
            showSystemBoundary={true}
            systemBoundaryProps={{
              businessId: businessId,
              systemBoundary: systemBoundaryPackaging,
              setSystemBoundary: setSystemBoundaryPackaging,
              totalObjCategory: "packaging_ingoing_delivery",
              customStyles: { marginTop: "10px" },
              isInventory: true,
            }}
          />
        </div>
        {showTable && (
          <InventoryPackagingTable
            businessId={businessId}
            subcategory={"packaging_ingoing_delivery"}
          />
        )}
        <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
      </div>
    </div>
  );
};

export default InventoryIngoingPackaging;
